import { ApiV2 } from '../../commonv2/api/ApiV2';
import { locatePath } from '../../common/RelativeUrl';
import { PlanId } from '../types/plan';
import { SplitCount } from '../containers/common/payment/states/CardPaymentState';

export const TicketApis = {
    base() {
        return new ApiV2(locatePath('/api/v2/new_tickets'));
    },
    async purchaseTickets(planId: PlanId, splitCount: SplitCount, campaignCode: string): Promise<void> {
        return await this.base().post({ plan_id: planId, split_count: splitCount, campaign_code: campaignCode });
    },

    async remainingTickets(): Promise<number> {
        return await this.base()
            .appendPath('remaining_tickets')
            .get();
    },
};
